export default __webpack_public_path__ + "static/media/applemusic.c7e113e2.png";